import React from "react";
import "./privacy-policy.style.scss";

function PrivacyPolicy(props) {
  return (
    <div className="privacy">
      <h1 className="privacy-heading">
        PRIVACY POLICY AND GENERAL TERMS AND CONDITIONS OF use of the platform with electronic services for e/m-Signature and e/m-Stamp and mobile application mPotpis
      </h1>
      <h1 className="privacy-heading">
      Ministry of Justice, Public Administration and Digital Transformation
      </h1>

      <div className="privacy-content">
        <p>Content</p>

        <ul className="privacy-list">
          <li>
            <a href="#introductory-provisions">1. Introductory provisions</a>
          </li>
          <li>
            <a href="#definitions-terms">2. Definitions/terms</a>
          </li>
          <li>
            <a href="#scope">
              3. Scope of the general terms and conditions of use
            </a>
          </li>
          <li>
            <a href="#use">4. Use of e/m-sSgnature and e/m-Stamp service</a>
          </li>
          <li>
            <a href="#data-privacy">5. Data privacy protection</a>
          </li>
          <li>
            <a href="#accountability">6. Accountability</a>
          </li>
          <li>
            <a href="#complaints">7. Handling of complaints</a>
          </li>
          <li>
            <a href="#final-provision">8. Final provisions</a>
          </li>
        </ul>

        <p>
          <a href="#anex1">Annex 1</a>: Notice on the protection of personal data at the Ministry of Justice, Public Administration and Digital Transformation for the use of
          the e/m-Signature and e/m-Stamp
        </p>
      </div>

      <section id="introductory-provisions">
        <h3>1. Introductory provisions</h3>
        <p>
          <strong>1.1.</strong> These general terms and conditions of use of the platform with electronic 
          services for e/m-Signature and e/m-Stamp and mobile application mPotpis (hereinafter referred to as the platform) 
          regulate the rules of use of the platform by natural persons or authorised representatives of legal entities. 
          The platform consists of a web and mobile application and corresponding API components for integration with the information systems of public law bodies. 
          By using the platform, you accept these General terms and conditions and give your consent to the processing of personal data.
        </p>
        <p>
          <strong>1.2.</strong> By accepting these General terms and conditions, users agree to
          use the platform only in accordance with their original purpose, their
          legitimate purpose and in a way that does not endanger, restrict or
          prevent the operation and use by third parties.
        </p>
        <p>
          <strong>1.3.</strong> Read the general terms of use carefully before using the platform
          service provided by Ministry of Justice, Public Administration and Digital Transformation.
        </p>
        <p>
          <strong>1.4.</strong> This act contains legally binding terms and conditions necessary
          for the use of the platform. The platform shall create/embed a
          qualified electronic signature having the same legal effect as the
          handwritten signature of several trust service providers pursuant to
          Regulation (EU) No 910/2014 of the European Parliament and of the
          Council of 23 July 2014 on electronic identification and trust
          services for electronic transactions in the internal market and
          repealing Directive 1999/93/EZ.
        </p>
        <p>
          <strong>1.5.</strong> Any questions or comments concerning the functioning of the
          platform shall be addressed to the email address: <a href="mailto:potpis.pecat@rdd.gov.hr">potpis.pecat@rdd.gov.hr</a>
        </p>
        <p>
          <strong>1.6.</strong> Any request or question relating to the processing of personal
          data as well as withdrawal of consent to the processing of personal
          data may be submitted in writing to: Ministry of Justice, Public Administration and Digital Transformation, Ivan Lucic 8, 10000 Zagreb or by
          e-mail to: <a href="mailto:zastitapodataka@rdd.hr">zastitapodataka@rdd.hr</a>
        </p>
        <p>
          <strong>1.7.</strong> The service will be provided in accordance with these General
          terms and conditions of use, and the handling of complaints or the
          enforcement of legal claims by users and in accordance with the
          Privacy Notice (see Annex 1). By accepting these General terms and
          conditions of use, the User agrees to transfer some of their personal
          and/or business data in accordance with the Privacy Notice, which is
          an integral part of the General terms and conditions of use.
        </p>
        <p>
          <strong>1.8.</strong> Ministry of Justice, Public Administration and Digital Transformation
          reserves the right to amend and/or supplement the General terms and
          conditions without prior notice, of which users/cross-border users
          will be informed in due time
        </p>
        <p>
          <strong>1.9.</strong> These General terms and conditions shall apply from 20 March
          2023.
        </p>
      </section>

      <section id="definitions-terms">
        <h3>2. Definitions/terms</h3>

        <p>
          <strong>2.1.</strong> “User” means a natural person or authorised representative of a
          legal person using a service and holding a valid signing certificate
        </p>

        <p>
          <strong>2.2.</strong> “Platform” means a platform with electronic services for
          e/m-Signature and e/m-Stamp of the Republic of Croatia as a joint
          shared public administration service established
        </p>

        <p>
          <strong>2.3.</strong> “Service provider” is the Republic of Croatia, Ministry of Justice, Public Administration and Digital Transformation
        </p>

        <p>
          <strong>2.4.</strong> supported means for the creation of a qualified electronic
          signature and a qualified electronic seal are all means fulfilling the
          conditions laid down for qualified certificates pursuant to Regulation
          (EU) No 910/2014 of the European Parliament and of the Council of 23
          July 2014 on electronic identification and trust services for
          electronic transactions in the internal market and repealing Directive
          1999/93/EZ.
        </p>
      </section>

      <section id="scope">
        <h3>3. Scope of the general terms and conditions of use</h3>

        <p>
          <strong>3.1 </strong>The platform can only be used by a user with a valid qualified
          electronic signature and a qualified electronic seal in accordance
          with the conditions laid down for qualified certificates pursuant to
          Regulation (EU) No 910/2014 of the European Parliament and of the
          Council of 23 July 2014 on electronic identification and trust
          services for electronic transactions in the internal market and
          repealing Directive 1999/93/EZ. The use of the platform by natural
          persons who do not fulfil this condition is not authorised and is
          considered to be a violation of these General terms and conditions of
          use.
        </p>

        <p>
          <strong>3.2.</strong> The general terms and conditions of use shall enter into force
          from the date specified under the heading until they are abolished.
        </p>

        <p>
          <strong>3.3.</strong> The Republic of Croatia, Ministry of Justice, Public Administration and Digital Transformation
          reserves the right to change the
          manner and circumstances of the operation of the platform in
          accordance with the provisions applicable to amendments to the General
          terms and conditions of use and to cease providing or restricting the
          operation of the platform.
        </p>

        <p>
          <strong>3.4.</strong> If any provision of the general terms and conditions is or
          becomes invalid or unenforceable, this will not affect the validity of
          the remaining provisions.
        </p>

        <p>
          <strong>3.5.</strong> If these General terms and conditions are modified, the service
          provider shall disclose: the fact of the amendment, the date of entry
          into force of the amendment and draw up a new text of the general
          terms and conditions in force from that date on the website and make
          it available from the date of entry into force of the amendment.
        </p>

        <p>
          <strong>3.6.</strong> If the user continues to use the platform after the date of entry
          into force of the change to the General terms and conditions of use,
          the user shall be deemed to have accepted the new General terms and
          conditions of use with the modified content.
        </p>
      </section>

      <section id="use">
        <h3>4. Use of e/m-sSgnature and e/m-Stamp service</h3>
        <p>
          <strong>4.1.</strong> The use of the platform is subject to compliance with these
          General terms and conditions and compliance with the provisions
          contained therein.
        </p>

        <p>
          <strong>4.2.</strong> The service provider may suspend the service during the period of
          completion of the necessary maintenance work.
        </p>

        <p>
          <strong>4.3.</strong> The service provider may refuse to provide the service and may
          terminate the provision of the service to the user with immediate
          effect if required by law or by an official/judicial decision or if
          the Platform is used in contravention of the General terms and
          conditions of use or otherwise unlawfully or improperly, taking into
          account the purpose of the service
        </p>

        <p>
          <strong>4.4.</strong> When creating an electronic signature of a document, the user
          shall determine whether or not the electronic signature of the
          document includes a visual representation of the electronic signature
          or seal on the document. In accordance with legal regulations, the
          visual representation of the electronic signature and/or seal does not
          represent and does not have the characteristics of the electronic
          signature and/or seal itself.
        </p>

        <div>
          <p><strong>4.5.</strong> Technical conditions for the use of the platform service:</p>
          <p>
            For the use of the platform, the user shall ensure the following
            technical conditions:
          </p>

          <ul>
            <li>
              personal computer with Windows (version 7 or higher) or Linux
              (Ubuntu 16.04.2 or higher) operating system and installed
              appropriate software provided by the selected trust service
              provider whose certificate the user signs documents on the
              platform
            </li>
            <li>Internet access</li>
            <li>
              smart card reader, integrated or external USB with minimum
              specifications:
              <ul>
                <li>ISO7816</li>
                <li>PC/SC compliance</li>
                <li>
                  appropriate driver for the operating system of the computer
                </li>
                <li>USB 2.0.</li>
              </ul>
            </li>
            <li>
              one of the following Internet browsers is installed:
              <ul>
                <li>Google Chrome - versions 43 and above</li>
                <li>Internet Explorer - versions 11 and more</li>
                <li>Opera - versions 30 and above</li>
                <li>Firefox - versions 41 and above</li>
              </ul>
            </li>
            <li>
              within the selected Internet browser:
              <ul>
                <li>pop-ups</li>
                <li>executing JavaScript code</li>
                <li>communication with local signatory services</li>
              </ul>
            </li>
          </ul>
        </div>

        <p>
          <strong>4.6.</strong> The Republic of Croatia, Ministry of Justice, Public Administration and Digital Transformation, is not responsible in case of
          inability to use the platform due to inappropriate user behaviour.
        </p>

        <p>
          <strong>4.7.</strong> The Republic of Croatia, Ministry of Justice, Public Administration and Digital Transformation, is not responsible for the
          unavailability of the platform resulting from technical problems or
          force majeure
        </p>

        <p><strong>4.8.</strong> Service procedure</p>

        <p>
          <strong>4.8.1.</strong> The user shall access the platform and confirm its intention to
          sign or seal the document electronically by clicking the button on the
          graphical interface of the platform. In doing so, the Platform does
          not enter into the content of the document or verify the legal
          authority to sign the document, which is the sole responsibility of
          the user.
        </p>

        <p>
          <strong>4.8.2.</strong> A summary (hash) of the user&rsquo;s document is then generated
          and the document is prepared for signature.
        </p>

        <p>
          <strong>4.8.3.</strong> Once the user enters the correct PIN of the signing certificate
          he/she owns, or after he/she successfully performs authentication
          actions (if the platform accesses in the e-citizens system), the
          platform creates a digitally signed document and the user can download
          it.
        </p>
      </section>

      <section id="data-privacy">
        <h3>5. Data privacy protection</h3>

        <p>
          <strong>5.1.</strong> Detailed provisions relating to the processing of the
          user&rsquo;s data and the Notice on the Protection of personal data
          are set out in Annex 1.
        </p>
        <p>
          <strong>5.2.</strong> The service provider shall process data made available by the
          user in accordance with applicable laws and regulations, both from the
          EU, in particular Regulation (EU) 2016/679 of the European Parliament
          and of the Council of 27 April 2016 on the protection of individuals
          with regard to the processing of personal data and on the free
          movement of such data, and repealing Directive 95/46/EZ (General data
          Protection Regulation, hereinafter referred to as “GDPR”) and
          Croatian.
        </p>
      </section>

      <section id="accountability">
        <h3>6. Accountability</h3>
        <p><strong>6.1.</strong> Liability of the Platform owner</p>
        <p>
          <strong>6.1.1.</strong> The owner of the platform shall not be liable for any
          consequences resulting from infringements by users of the provisions
          of these general terms and conditions of use, including but not
          limited to events which may be related to incorrect user use of the
          platform, behaviour or infringement by users, etc., accepted by the
          user.
        </p>
        <p>
          <strong>6.1.2.</strong> The liability of the platform owner will be limited to
          liability for the behaviour and damage caused by the deliberate
          behaviour of the platform owner. In addition, the owner of the
          platform will not be liable for any direct or indirect damage
          resulting from the use of the platform, including but not limited to
          lost profits and consequent damage.
        </p>
        <p>
          <strong>6.1.3.</strong> The owner of the platform is not obliged to bear or compensate
          for damage attributable to circumstances beyond its control.
        </p>

        <p>
          <strong>6.1.4.</strong> The owner of the platform cannot be held liable for technical
          disturbances, including but not limited to any delays in electrical,
          internet or computer networks.
        </p>

        <p>
          <strong>6.1.5.</strong> The owner of the platform shall not take responsibility for any
          damage caused by the use, maladministration or deletion of any part or
          content of the website.
        </p>

        <p><strong>6.2.</strong> Responsibility of the beneficiary</p>

        <p>
          <strong>6.2.1.</strong> Users are obliged to bear or make good any damage resulting
          from violations of the requirements set out in the General terms and
          conditions of use.
        </p>
        <p>
          <strong>6.2.2.</strong> Beneficiaries will be relieved of liability if they show that
          the breach of the general conditions of use is caused by circumstances
          beyond their control which could not have been foreseen in accepting
          them and cannot be expected to circumvent that circumstance or prevent
          damage.
        </p>

        <p>In particular, beneficiaries shall be responsible for:</p>

        <p>
          <strong>6.2.3.</strong> The user assumes responsibility and guarantees that they use
          the service only with supported means to create a qualified electronic
          signature that comply with the applicable laws, regulations and
          standards applicable to the provision of trust services. The user
          shall be liable for any damage resulting from the use of a service
          with inappropriate means of producing a qualified electronic
          signature.
        </p>

        <p>
          <strong>6.2.4.</strong> The prerequisite for using the service is that users must not
          use the platform for purposes other than those laid down in these
          General terms of use and legislation. Users may use the platform only
          in person or if they are authorised to do so. Users are responsible
          for all activities related to the use of the platform.
        </p>
      </section>

      <section id="complaints">
        <h3>7. Handling of complaints</h3>

        <p>
          <strong>7.1.</strong> Users may lodge a complaint via the e-mail address of the{" "}
          <a href="mailto:potpis.pecat@rdd.gov.hr">potpis.pecat@rdd.gov.hr</a>
        </p>

        <p>
          <strong>7.2.</strong> The platform owner shall send a response regarding the validity
          of the complaint to the user through the contact specified by the user
          in the complaint within thirty (30) days. The service provider shall
          state the reasons for the rejection decisions.
        </p>

        <p>
          <strong>7.3.</strong> The owner of the platform shall keep the complaint and a copy of
          the response concerning the merits of the complaint for a period of 1
          year and present them at the request of the competent authorities
          auditing such cases.
        </p>
      </section>

      <section id="final-provision">
        <h3>8. Final provisions</h3>

        <p><strong>8.1.</strong> Force majeure</p>

        <p>
          Does not constitute an infringement if either party is unable to
          fulfil its obligations under these General terms and conditions of use
          for any reason not attributable to either party (force majeure). An
          event of force majeure includes all unforeseen events that cannot be
          prevented by man (e.g. war, earthquake, flood, fire, act of terrorism,
          etc.), which do not depend on the will of the parties and directly
          interfere with a party in fulfilling its agreed obligation.
        </p>

        <p>
          The contractual time limits shall be extended for the duration of
          force majeure.
        </p>

        <p>
          The platform owner shall notify the threat or occurrence of a force
          majeure event and its intended duration through the platform owner,
          but the platform owner shall not be liable and shall not affect the
          provision of services by the trust service provider.
        </p>

        <p>
          <strong>8.2.</strong> The parties agree that all issues regulated by these General
          terms and conditions of use will be resolved by applying the rules of
          Croatian law.
        </p>

        <p>
          <strong>8.3.</strong> The parties will seek to resolve any disputes regarding the use
          of the platform peacefully. Disputes that cannot be settled peacefully
          will be settled before the competent court in Zagreb, which has
          territorial jurisdiction.
        </p>

        <p>
          <strong>8.4.</strong> Annex 1 forms an inseparable part of the general conditions of
          use.
        </p>
      </section>

      <section id="anex1">
        <h3>Annex 1</h3>
        <h4>PERSONAL DATA PROCESSING INFORMATION</h4>
        <h4>CONTROLLER</h4>
        <p>
        Ministry of Justice, Public Administration and Digital Transformation, Ivan Lucic 8,
          10000 Zagreb
        </p>
        <h4>
          DATA TO BE COLLECTED, PURPOSE AND LAWFULNESS OF COLLECTION AND
          PROCESSING
        </h4>
        <p>
          We collect and process personal data for the purpose of performing
          tasks of public interest and our official authority and for the
          purpose of respecting legal obligations in accordance with the law or
          other Regulation of the Republic of Croatia and the law of the
          European Union. This shall include:
        </p>
        <ul>
          <li>
            processing of personal data to enable you to use the National
            identification and Authentication system (NIAS) and electronic
            credentials and certificates in accordance with the eIDAS Regulation
          </li>

          <li>
            processing of personal data to enable you to provide e-services
          </li>
          <li>processing of personal data to respond to a query</li>
        </ul>

        <p>Such processing may include the following categories of data:</p>
        <ul>
          <li>personal identification information of users</li>
        </ul>

        <p>Collection and processing of personal data is lawful based on:</p>
        <ul>
          <li>
            Article 6 (1) (c) requires processing in order to comply with legal
            obligations
          </li>
          <li>
            point (e) of Article 6 (1) is necessary for the performance of a
            task in the public interest or in the exercise of official authority
            by the controller of REGULATION (EU) 2016/679 of the EUROPEAN
            PARLIAMENT and of the COUNCIL of 27 April 2016 on the protection of
            individuals with regard to the processing of personal data and on
            the free movement of such data, and repealing Directive 95/46/EZ.
          </li>
        </ul>

        <h4>LEGITIMATE INTERESTS</h4>
        <p>
          The controller has a legitimate interest in collecting your personal
          data for the purpose of improving the functioning and improvement of
          the platform for statistical purposes. To this end, we can further
          collect your opinions, comments or suggestions, as well as an e-mail
          address to provide an answer.
        </p>
        <p>Collection and processing of personal data is lawful based on:</p>
        <ul>
          <li>
            point (f) of Article 6 (1) the legitimate interests of controllers
            or third parties to REGULATION (EU) 2016/679 of the EUROPEAN
            PARLIAMENT and of the COUNCIL of 27 April 2016 on the protection of
            individuals with regard to the processing of personal data and on
            the free movement of such data, and repealing Directive 95/46/EZ.
            You may object or restrict the processing. Failure to provide
            information will not result in negative consequences.
          </li>
        </ul>

        <h4>USE COOKIES</h4>
        <p>
          Under certain circumstances, we can collect and process personal data
          based on your prior consent. Such processing is carried out when we
          collect “cookies” to improve the operation of the system and to
          improve your user experience. At any time, you can withdraw your
          consent and stop further processing without negative consequences.
        </p>

        <p>
          The aforementioned collection and processing of personal data is
          lawful based on:
        </p>
        <ul>
          <li>
            Article 6 (1) (a) the data subject has given consent to the
            processing of his or her personal data for one or more specific
            purposes
          </li>
        </ul>
        <p>
          REGULATION (EU) 2016/679 of THE EUROPEAN PARLIAMENT and of the COUNCIL
          of 27 April 2016 on the protection of natural persons with regard to
          the processing of personal data and on the free movement of such data,
          and repealing Directive 95/46/EZ. More detailed information on the use
          of cookies can be found at the link: (use of cookies)
        </p>

        <h4>RECIPIENTS OF PERSONAL DATA</h4>
        <p>
          Controllers shall: we do not forward the data you provide to other
          controllers and do not disclose it to third parties except in certain
          circumstances where we are bound by the relevant regulations to the
          extent necessary to achieve the stated purpose.
        </p>
        <p>
          Processors: We can forward personal data for use to providers of it
          communication solutions and services acting as contracted processors.
          In that case, the processor shall process the personal data only on
          our order, on our behalf, in order to fulfil the purpose for which the
          personal data were collected and in a manner as determined by mutual
          agreement and in accordance with the requirements of the General
          Regulation. These may be the following processors:
        </p>
        <ul>
          <li>
            Agency for commercial activities manufacturing, Service and
            commercial Ltd., Savska cesta 31, 10 000 Zagreb
          </li>
          <li>Financial Agency, Ulica grada Vukovara 70, 10000 Zagreb</li>
        </ul>

        <h4>OTHER PAGES AND LINKS</h4>
        <p>
          When you follow the link to a service provided by a ministry, state
          administrative organisation, agency, office and other body or
          institution using the platform site, then that organisation will be
          independent controller and responsible for the data you share with
          them. It will apply its own privacy policy and provide its
          notification of the processing of personal data.
        </p>
        <p>
          For example, when you want to submit an e-application for a passport,
          you will be redirected to the provider&rsquo;s website and{" "}
          <a
            href="https://eputovnica.mup.hr"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://eputovnica.mup.hr
          </a>
          . This site will have privacy policies that will inform you about the
          processing of your personal data related to the requested service and
          provide you with information on how to exercise your rights.
          Therefore, before using a particular service, it is recommended to
          familiarize yourself with the privacy policy of the service provider.
        </p>

        <h4>RETENTION PERIOD OF PERSONAL DATA</h4>
        <p>
          We process the collected personal data until the purpose of collecting
          personal data is met. Once the purpose for which the data were
          collected has been fulfilled, the data are no longer used and stored
          in the data controller&rsquo;s storage systems where they are stored
          in accordance with the legal regulations on archival preservation.
        </p>
        <h4>YOUR RIGHTS IN RELATION TO THE PROCESSING OF PERSONAL DATA</h4>
        <p>You have the right to require:</p>
        <ul>
          <li>
            information about how your personal data are processed: you may
            request detailed information, in particular about their purpose of
            processing, about the type/of personal data being processed,
            including insight into your personal data, about recipients or
            categories of recipients, and about the envisaged period during
            which the personal data will be stored
          </li>
          <li>
            copy of personal data: a copy of the personal data being processed
            about you is provided. Additional copies may be charged on the basis
            of administrative costs
          </li>
          <li>
            correction of incorrect data: You have the right to request the
            correction or supplementation of personal data if your data is
            incorrect, complete and up to date
          </li>
        </ul>

        <p>You can also:</p>

        <ul>
          <li>object to the way your personal data are processed</li>
          <li>request the deletion of your personal data</li>
          <li>
            require that the processing of your personal data is restricted in
            certain circumstances
          </li>
          <li>
            request the deletion of your personal data
            <ul>
              <li>
                the law shall not apply to the extent that processing is
                necessary
              </li>
              <li>
                to exercise the right to freedom of expression and information
              </li>
              <li>
                in order to comply with a legal obligation requiring processing
                in Union or Croatian law or for the performance of a task in the
                public interest or in the exercise of official authority by the
                controller
              </li>
              <li>
                for archiving purposes in the public interest, scientific or
                historical research purposes or statistical purposes to the
                extent that the exercise of rights is likely to render
                impossible or seriously jeopardise the achievement of the
                objectives of that processing
              </li>
              <li>
                for the establishment, exercise or defence of legal claims
              </li>
            </ul>
          </li>
        </ul>
        <p>
          We will notify you of the request within 30 days by regular electronic
          means unless you request otherwise.
        </p>

        <h4>PROCESSING SECURITY</h4>
        <p>
          We collect and process personal data in a manner that ensures an
          adequate level of security and a high level of confidentiality in
          their processing by ensuring the effective application of the data
          protection principles, including protection against unauthorised or
          unlawful processing and against accidental loss, destruction or damage
          by applying appropriate technical and organisational protection
          measures
        </p>

        <h4>CONTACTS</h4>
        <p>
          For questions related to the collection and processing of personal
          data through the e-citizens system or in order to exercise your
          rights, you can contact:
        </p>
        <ul>
          <li>
          Ministry of Justice, Public Administration and Digital Transformation Ivan Lucic 8,
            10000 Zagreb
          </li>
          <li>
            Data Protection Officer: email:{" "}
            <a href="mailto:zastitapodataka@rdd.hr">zastitapodataka@rdd.hr</a>,
            tel.: <a href="tel:+38514400840">+385 1 44 00 840</a>
          </li>
        </ul>

        <p>
          Where you believe that your personal data have been infringed, you may
          lodge a complaint with the supervisory authority:
        </p>
        <ul>
          <li>
            Personal data Protection Agency,{" "}
            <a href="https://azop.hr" target="_blank" rel="noopener noreferrer">
              https://azop.hr
            </a>
            , Selska cesta 136, Zagreb,
          </li>
        </ul>

        <h4>PRIVACY POLICY CHANGE NOTIFICATION</h4>
        <p>
          We regularly update our privacy policy and for this reason there may
          be a necessary change of content. You will be informed about all
          amendments in a timely manner via this website.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
